<template>
  <div class="message-record-recharge">
    <tableBox
        :tableData="tableData"
        :tableHead="tableHead"
        :total="total"
        :size="pageSize"
        @pageHandler="pageOperate"></tableBox>
  </div>
</template>

<script>
  import tableBox from '@/components/table/table'
  export default {
    name: 'message-record-recharge',
    components:{
      tableBox
    },
    data() {
      return {
        tableData: [],
        tableHead: [
          {
            label: '充值时间',
            value: 'createTime',
            operate: false
          }, {
            label: '充值前可用短信数量(条)',
            value: 'rechargeBeforeMsgNum',
            operate: false,
          }, {
            label: '充值短信数量(条)',
            value: 'rechargeMsgNum',
            operate: false
          },{
            label: '充值后可用短信数量(条)',
            value: 'rechargeAfterMsgNum',
            operate: false,
          }, {
            label: '充值方式',
            value: 'rechargeTypeDesc',
            operate: false,
          },{
            label: '充值金额(元)',
            value: 'rechargeAmount',
            operate: false,
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    },
    created(){
      this.getRechargeRecord()
    },
    mounted() {

    },
    methods: {
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getRechargeRecord()
      },
      getRechargeRecord(){
        let postData = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        this.$http.msgRechargeRecordAPI(postData).then( res => {
          if (res.status == 1) {
            this.tableData = res.data.list
            this.total = res.data.total
          }
        })
      }
    }
  }
</script>

<style lang="scss">

</style>
